<div class="mr-xsmall-b">
  @if (phraseGroup().title) {
    <h4>{{ phraseGroup().title }}</h4>
  }
  <dl class="phrases-list">
    @for (phrase of phraseGroup().phrases; track $index) {
      <div class="cf">
        <dt [innerHTML]="phrase.site | finSafe: 'html'"></dt>
        <dd [innerHTML]="phrase.local | finSafe: 'html'"></dd>
      </div>
    }
  </dl>
</div>
